import { UserType } from "../../services/medicationmanagement/medsUser/MedsUserApi";
import { DownloadFile } from "../common/download-file/DownloadFile";
import { PractitionerHpiiDetails } from "../common/popover/hpii-details/PractitionerHpiiDetails";
import { patientService } from "../../services/medicationmanagement/patientApi/PatientApi";
import { Box, Grid } from "@material-ui/core";
import { ExternalLookupIdentifier } from "@communicare/medications/Shared/SharedModels";
import { Patient } from "../../services/medicationmanagement/patientApi/models/Patient";
import styles from "./ResidentHeader.module.scss";
import { IndividualHealthcareIdentifier } from "../../services/healthcareidentifier/models/IndividualHealthcareIdentifier";
import { PatientIhiDetails } from "../common/popover/ihi-details/PatientIhiDetails";
import { RenderIf } from "../common/render-if/RenderIf";

export interface IResidentTopBarProps {
    resident: Patient;
    encounter: ExternalLookupIdentifier;
    ihi: IndividualHealthcareIdentifier;
    userType: UserType;
}

export const ResidentTopBar = (props: IResidentTopBarProps) => {
    let { resident, encounter } = props;

    return (
        <Grid container direction={"row"} item className={styles.topNavigationMenu}>
            <Box className={styles.residentName}>
                {resident?.familyName}, {resident?.givenName} (
                {resident?.preferredName})
            </Box>
            <Box className={`${styles.rightAlignButton} ${styles.buttons}`}>
                <DownloadFile
                    downloadPath={
                        patientService.getMedchartPrintPDFPath(resident?.authoringSystem || "", resident.authoringSystemForeignKey || "")
                    } userType={props.userType}
                />
                <PatientIhiDetails ihi={props.ihi} resident={props.resident} />
                <RenderIf if={props.userType === UserType.Doctor 
                                || props.userType === UserType.Dentist 
                                || props.userType === UserType.NursePractitioner 
                                || props.userType === UserType.Optometrist}> 
                    <PractitionerHpiiDetails encounterAuthoringSystem={encounter.authoringSystem} encounterAuthoringSystemForeignKey={encounter.authoringSystemForeignKey} />
                </RenderIf>
            </Box>

        </Grid>
    );
};